import React from 'react';

export const Margin = (props: any) => {
    return (
        <div style={{ marginTop: props.tm, marginLeft: props.lm, marginRight: props.rm, marginBottom: props.bm }}></div>
    );
};
